import { render, staticRenderFns } from "./Minderlieferung.vue?vue&type=template&id=504b00e2&scoped=true&"
import script from "./Minderlieferung.vue?vue&type=script&lang=js&"
export * from "./Minderlieferung.vue?vue&type=script&lang=js&"
import style0 from "./Minderlieferung.vue?vue&type=style&index=0&id=504b00e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b00e2",
  null
  
)

export default component.exports